<template>
  <div :class="componentClassName">
    <slot>
      <img src="@/images/application-complete-logo.svg" />
    </slot>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'a-vdxb-application-complete-sign',
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-vdxb-application-complete-sign');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
